import RejectController from 'eflex/pods/codes/reject/controller';

export default class CodesScrapController extends RejectController {
  get codes() {
    return this.codeRepo.scrapCodes;
  }
}
